import React, { FC } from 'react';
import Link from 'next/link';
import { ProfileTab as Tab, ProfileTabType } from '@domain/constant/ProfileTabType';
import { AccaRouteUrl, V2RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './profileTab.module.scss';
const cx = classnames.bind(styles);

interface IProfileTab {
  profileTabType: ProfileTabType;
}

const ProfileTab: FC<IProfileTab> = ({ profileTabType }) => {
  const isOn = (profileTab: ProfileTabType) => profileTab === profileTabType;

  return (
    <div className={cx('tabArea')}>
      <Link href={V2RouteUrl.PROFILE} legacyBehavior>
        <a className={cx('tab', { on: isOn(Tab.PROFILE) }, 'gnb_mypage_profile')} role="button">
          프로필
        </a>
      </Link>
      <Link href={AccaRouteUrl.ACCA_RESULTS} legacyBehavior>
        <a className={cx('tab', { on: isOn(Tab.ACCA_RESULTS) }, 'gnb_mypage_acca_results')} role="button">
          역검 결과
        </a>
      </Link>
      <Link href={V2RouteUrl.PHS_PACC_RESULTS} legacyBehavior>
        <a className={cx('tab', { on: isOn(Tab.PHS_RESULTS) }, 'gnb_mypage_pacc_results')} role="button">
          개발자 검사 결과
        </a>
      </Link>
    </div>
  );
};

export default ProfileTab;
